export const CONTACT_ADMINISTRATOR_ID = 'contact-administrators';
export const SUBJECT_LENGTH = 1000;
export const DETAILS_LENGTH = 10000;
export const CONTACT_ADMINT_PACKAGE_NAME = 'jiraAdminPagesContactAdministrator';
